// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"6aef908b","452":"8f7ce8c3","500":"dce0f501","586":"7b72fcd7","645":"72815b1a"}[chunkId] + ".css";
};